<div class="resource-detail-container fx-column fx-start-stretch fx-fill">
	<ng-container *ngIf="(noData || permissionError) && patchMessage">
		<div class="fx-row fx-center-start content-note">
			<div class="fx-row fx-center-start content-note">
				<div class="no-content-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
					<div fxLayoutAlign="center center">
						<mat-icon svgIcon="oops"></mat-icon>
					</div>
					<p class="caption-2">
						{{locale.translate(patchMessage)}}
					</p>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="!noData && !permissionError">
		<app-classic-content-view [features]="features" [additionalData]="CCVAdditionalData" [optionMenu]="optionMenu"
			[progress]="(resourceDetail?.resourceAction?.progressBar) ? resourceDetail?.completedPercent : null"
			[featureLoader]="featureLoader || (detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? !processed : false)"
			[contentLoader]="resourceLoader || (detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? !processed : false)"
			(assignmentEmit)="manageAssignment($event)" (manage)="manage($event)" class="resource-classic-panel"
			(rating)="rating($event)" (profile)="searchPeopleDetail(authorData)" (users)="getUsersProfile()"
			(optionInfo)="optionInfo($event)">
			<content-header class="resource-header-area">
				<!-- <div class="moderation-info" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px"
            fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="8px">
            <div class="moderation-process" fxLayout="row wrap" fxLayoutAlign="start center" fxLayout.xs="column"
                fxLayoutAlign.xs="start stretch" fxLayoutGap="18px" fxLayoutGap.xs="10px">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px">
                <mat-icon class="General-icon">filter_vintage</mat-icon>
                <p class="changes-desc">Changes made to this document are waiting for moderation.</p>
                </div>
                <div class="button-blk" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px" fxLayoutGap.xs="4px">
                <button class="striped-btn" mat-button>Publish</button>
                <button class="striped-btn" mat-button>Reject</button>
                <button class="primary-btn" mat-button>Guidlines</button>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                <div class="sub-txt-patch">orginal</div>
            </div>
						</div> resourceLoader || assignmentLoader -->

				<ng-container *ngIf="headerType === 'playlist'">
					<div class="playlist-header">
						<ng-container *ngIf="playlistLoader">
							<loader [loader]="true" [type]="'playlist-header-shimmer'" [classes]=""></loader>
						</ng-container>
						<div class="playlist-content-header"
							[ngClass]="{'fx-row fx-space-between-center' : !detectDevice?.resolutionState$?.value?.xs, 'fx-column fx-start-stretch' : detectDevice?.resolutionState$?.value?.xs}">
							<div class="playlist-menu"
								[ngClass]="{'fx-row fx-start-center fx-grow fx-shrink' : !detectDevice?.resolutionState$?.value?.xs, 'fx-column fx-start-stretch fx-no-grow fx-no-shrink' : detectDevice?.resolutionState$?.value?.xs}">
								<app-playlist-panel [actionType]="actionType" [playlistData]="playlistData"
									[playlistParentData]="playlistParentData" (pageActions)="pageActions($event)" class="playlist-panel">
								</app-playlist-panel>
								<ng-container *ngIf="playlistData?.length > 1">
									<mat-divider fxHide fxShow.xs></mat-divider>
									<app-playlist-pagination [playlistData]="playlistData" [selectedIndex]="selectedPlaylistQueueIndex"
										[actionBtns]="actionBtns" (playActions)="playActions($event)" class="playlist-pagination">
									</app-playlist-pagination>
								</ng-container>
							</div>
						</div>
					</div>
					<mat-divider></mat-divider>
				</ng-container>
				<!-- <ng-container *ngIf="headerType !== 'playlist' && [null, 'playlist', undefined, ''].includes(actionFrom)"> -->
				<!-- <ng-container *ngIf="resourceDetail?.resourceAction?.assignment">
					<div class="assignment-header" [ngClass]="{'loading': assignmentLoader}">
						<ng-container *ngIf="assignmentLoader">
							<loader [loader]="true" [type]="'user-row-shimmer'" [classes]=""></loader>
						</ng-container>
						<ng-container
							*ngIf="(type && assignmentDetail && assignmentDetail?.status.key !== 'closed') || reloadAssignment">
							<app-assignment-info [resourceID]="resourceID" [resourceData]="resourceDetail"
								[actualAssignmentID]="assignmentID" [viewType]="'info'" [type]="type"
								(infoLoader)="assignmentLoader = $event?.loader" (assignmentEmit)="assignmentInfo($event)"
								class="assignment-info-comp">
							</app-assignment-info>
							<ng-container *ngIf="resourceDetail?.status?.key === 'moderation'">
								<mat-divider></mat-divider>
							</ng-container>
						</ng-container>
					</div>
				</ng-container> -->
				<ng-container *ngIf="resourceDetail?.resourceAction?.assignment">
					<!-- <div [ngClass]="{'assignment-header': !assignmentLoader}"> -->
					<ng-container
						*ngIf="(type && assignmentDetail && !['closed', 'aborted'].includes(assignmentDetail?.status.key)) || reloadAssignment">
						<app-assignment-info [resourceID]="resourceID" [resourceData]="resourceDetail"
							[actualAssignmentID]="assignmentID" [viewType]="'info'" [type]="type"
							(infoLoader)="assignmentLoader = $event?.loader" (assignmentEmit)="assignmentInfo($event)"
							class="assignment-info-comp">
						</app-assignment-info>
						<ng-container *ngIf="resourceDetail?.status?.key === 'moderation'">
							<mat-divider></mat-divider>
						</ng-container>
					</ng-container>
					<!-- </div> -->
				</ng-container>

				<ng-container
					*ngIf="resourceDetail?.status?.key === 'moderation' && resourceDetail?.resourceAction?.publishUnPublish">
					<div class="moderation-header-block fx-column fx-start-stretch">
						<div class="moderation-header-item"
							[ngClass]="{'fx-row fx-start center fx-grow fx-shrink' : !detectDevice?.resolutionState$?.value?.xs, 'fx-column fx-start-stretch' : detectDevice?.resolutionState$?.value?.xs}">
							<div class="moderation-content fx-row fx-start-center">
								<ng-container *ngIf="resourceDetail?.createdUser?.profilePicURL">
									<!-- <mat-icon class="mod-icon" svgIcon="moderation"></mat-icon> -->
									<img [src]="resourceDetail?.createdUser?.profilePicURL"
										(error)="gfService.setErrorImage($event, 'man')" class="thumbnail">
								</ng-container>
								<span class="user-submit-dtl sub-caption-1"
									[innerHtml]="locale.translate('user_has_submitted_this_for_moderation') | handleBar : { 'user' : resourceDetail?.createdUser?.name }"></span>
							</div>
							<div class="button-block fx-row fx-start-center">
								<button class="sub-action-btn" mat-stroked-button #publishAction
									(click)="alertPopup('publish',null, {'actionElement': publishAction})"
									[disabled]="publishButtonDisable">{{locale.translate('publish')}}</button>
								<button class="sub-action-btn" mat-stroked-button #rejectAction
									(click)="reject(rejectAction)">{{locale.translate('reject')}}</button>
								<p class="hyperlink cursor-pointer" (click)="guideline()">{{locale.translate('guidelines')}}</p>
								<!-- <button class="cancel-btn" (click)="guideline()" mat-button type="button">{{locale.translate('guidelines')}}</button> -->
							</div>
						</div>
					</div>
				</ng-container>

			</content-header>
			<classic-content-title *ngIf="processed" class="resource-title">
				{{resourceDetail?.title}}
			</classic-content-title>
			<content-area class="resource-content-area">
				<ng-container *ngIf="processed">
					<div class="fx-column fx-start-stretch">
						<ng-container *ngIf="resourceDetail?.resourceTypeID?.key === 'knowledgecard'">
							<app-detail [resourceDetail]="resourceDetail" [status]="assignmentDetail?.status"></app-detail>
						</ng-container>
						<ng-container *ngIf="resourceDetail?.resourceTypeID?.key === 'playlist' && headerType !== 'playlist'">
							<app-playlist-detail [resourceDetail]="resourceDetail" [additionalData]="CCVAdditionalData"
								(profileDetail)="searchPeopleDetail($event)">
							</app-playlist-detail>
						</ng-container>
						<ng-container *ngIf="resourceDetail?.resourceTypeID?.key === 'answer'">
							<app-questions-detail [resourceDetail]="resourceDetail" [closeQuestion]="closeQuestion"
								(joined)="joined($event)" (loading)="resourceLoader = $event"></app-questions-detail>
						</ng-container>
						<ng-container *ngIf="resourceDetail?.resourceTypeID?.key === 'course'">
							<app-course-detail [resourceDetail]="resourceDetail" [additionalData]="CCVAdditionalData"
								[popupRef]="popupRef" (reloadResource)="reload($event)"></app-course-detail>
						</ng-container>
						<!-- <ng-container *ngIf="resourceDetail?.resourceTypeID?.key === 'mooc'">
							<app-mooc-detail [resourceDetail]="resourceDetail"></app-mooc-detail>
						</ng-container>
						<ng-container *ngIf="resourceDetail?.resourceTypeID?.key === 'event'">
							<app-event-detail [resourceDetail]="resourceDetail"></app-event-detail>
						</ng-container> -->
						<ng-container *ngIf="['internalEvent'].includes(resourceDetail?.resourceTypeID?.key)">
							<app-internal-event-detail [resourceDetail]="resourceDetail" (reloadResource)="reload($event)"
								(readLogEmit)="processReadForEvents()" [popupRef]="popupRef">
							</app-internal-event-detail>
						</ng-container>
						<ng-container *ngIf="['externalEvent'].includes(resourceDetail?.resourceTypeID?.key)">
							<app-external-event-detail [resourceDetail]="resourceDetail" (reloadResource)="reload($event)"
								(readLogEmit)="processReadForEvents()" [popupRef]="popupRef">
							</app-external-event-detail>
						</ng-container>
						<ng-container *ngIf="resourceDetail?.resourceTypeID?.key === 'mooc'">
							<app-mooc-detail [resourceDetail]="resourceDetail" [popupRef]="popupRef"
								(readLogEmit)="processReadForMOOC()">
							</app-mooc-detail>
						</ng-container>
						<ng-container
							*ngIf="resourceDetail?.resourceTypeID && !['knowledgecard', 'playlist', 'answer', 'course', 'mooc', 'internalEvent', 'externalEvent'].includes(resourceDetail?.resourceTypeID?.key)">
							<div class="resource-detail fx-column fx-start-stretch">
								<app-readability class="app-readability" [height]="(resourceDetail?.description) ? '18' : '0'">
									<content>
										<div class="fx-column fx-start-stretch">
											<ng-container *ngIf="resourceDetail?.description">
												<div class="resource-description">
													{{resourceDetail?.description}}
												</div>
											</ng-container>

											<ng-container *ngIf="resourceDetail?.skills?.length && skillMPermission">
												<div class="skill-pack fx-row-wrap fx-start-start">
													<ng-container *ngFor="let skill of resourceDetail?.skills">
														<app-chips type="progressive" background="var(--secondary-four)"
															[data]="{title: skill?.skill?.value, progress: skill?.skillLevel + '%', bufferColor: 'transparent', toolTip: true}">
														</app-chips>
													</ng-container>
												</div>
											</ng-container>

											<ng-container
												*ngIf="resourceDetail?.infoFields && (resourceDetail?.infoFields | objectKeys : []).length">
												<div class="fx-row fx-start-start">
													<ng-container *ngIf="resourceDetail?.infoData?.length">
														<ng-container *ngFor="let info of resourceDetail?.infoData">
															<app-common-view [data]="info"></app-common-view>
														</ng-container>
													</ng-container>
												</div>
											</ng-container>
										</div>
									</content>
								</app-readability>

								<ng-container
									*ngIf="resourceDetail?.resourceFormat?.key === 'image' && resourceDetail?.resource?.image?.length">
									<ng-container *ngIf="(detectDevice?.resolutionState$?.value?.xl  && resourceDetail?.resource?.image?.length <= 8)
												|| (detectDevice?.resolutionState$?.value?.lg && resourceDetail?.resource?.image?.length <= 6)
												|| ((detectDevice?.resolutionState$?.value?.md || detectDevice?.resolutionState$?.value?.sm) &&
												resourceDetail?.resource?.image?.length <= 4)
												|| (detectDevice?.resolutionState$?.value?.xs && resourceDetail?.resource?.image?.length <= 2)">
										<ng-container [ngTemplateOutlet]="imageReadability">
										</ng-container>
									</ng-container>

									<ng-container *ngIf="(detectDevice?.resolutionState$?.value?.xl  && resourceDetail?.resource?.image?.length > 8)
												|| (detectDevice?.resolutionState$?.value?.lg && resourceDetail?.resource?.image?.length > 6)
												|| ((detectDevice?.resolutionState$?.value?.md || detectDevice?.resolutionState$?.value?.sm ) &&
												resourceDetail?.resource?.image?.length > 4)
												||  (detectDevice?.resolutionState$?.value?.xs && resourceDetail?.resource?.image?.length > 2)">
										<app-readability class="app-readability" [height]="height" (readMore)="readMoreForImage($event)">
											<content>
												<ng-container [ngTemplateOutlet]="imageReadability">
												</ng-container>
											</content>
										</app-readability>
									</ng-container>

									<ng-template #imageReadability>
										<ng-container *ngIf="resourceDetail?.resourceAction?.edit">
											<div class="edit-link" fxLayout="row" fxLayoutAlign="end center"
												[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
												<p class="hyperlink" (click)="editImageResource()">{{locale.translate('edit')}}</p>
											</div>
										</ng-container>
										<div class="img-container" fxLayout="column" fxLayoutAlign="start stretch">
											<div class="img-list" fxFlex="1 1" fxLayout="row wrap" fxLayoutAlign="start stretch"
												fxLayoutGap="24px" fxLayoutGap.xs="0px">
												<ng-container *ngFor="let image of resourceDetail?.resource?.image;let i = index;">
													<div class="img-item cursor-pointer" (click)="viewImage(i, image)"
														[ngClass]="{'xl' : detectDevice?.resolutionState$?.value?.xl,'lg' : detectDevice?.resolutionState$?.value?.lg,'md' : detectDevice?.resolutionState$?.value?.md,'sm' : detectDevice?.resolutionState$?.value?.sm, 'xs' : detectDevice?.resolutionState$?.value?.xs}">
														<div fxFlex="1 1" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
															fxLayoutGap.xs="5px">
															<div class="thumbnail">
																<div class="ratio-content">
																	<img class="img" [ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}"
																		[src]="image?.file"
																		(error)="gfService.setErrorImage($event, 'broken_image'); image.error=true;">
																</div>
																<ng-container *ngIf="image?.caption && !detectDevice?.resolutionState$?.value?.xs">
																	<div class="thumbnail-overlay">
																		<p class="overlay-text">{{image?.caption}}</p>
																	</div>
																</ng-container>
															</div>
															<ng-container *ngIf="image?.caption && detectDevice?.resolutionState$?.value?.xs">
																<p class="caption-mob linkable" fxHide fxShow.xs>{{image?.caption}}</p>
															</ng-container>
														</div>
													</div>
												</ng-container>
											</div>
										</div>
									</ng-template>

								</ng-container>

								<ng-container *ngIf="(resourceDetail?.resource | objectKeys : []).length">
									<ng-container *ngIf="resourceDetail?.resourceFormat.key === 'video'">
										<div class="resource-content video-container">
											<div class="ratio-player">
												<ng-container *ngIf="resourceDetail?.resource?.file">
													<app-video-player [source]="resourceDetail?.resource?.file"
														[currentTime]="resourceDetail?.lastTimeline" [segmentsProcess]="!resourceDetail.read"
														[options]="{bookmarks: resourceDetail?.resource?.bookmark}" [canStartPlay]="canStartPlay"
														[thumbnail]="resourceDetail?.resource?.thumbnail" class="ratio-content"
														(segments)="segments($event)" (updatedTime)="updatedTime($event)">
													</app-video-player>
												</ng-container>
											</div>
										</div>
									</ng-container>
									<ng-container *ngIf="resourceDetail?.resourceFormat.key === 'audio'">
										<ng-container *ngIf="resourceDetail?.resource?.file">
											<app-audio-player [source]="resourceDetail?.resource?.file"
												[segmentsProcess]="!resourceDetail.read" [currentTime]="resourceDetail?.lastTimeline"
												[canStartPlay]="canStartPlay" class="resource-content audio-container"
												(segments)="segments($event)" (updatedTime)="updatedTime($event)">
											</app-audio-player>
										</ng-container>
									</ng-container>
									<ng-container *ngIf="resourceDetail?.resourceFormat.key === 'document'">
										<ng-container *ngIf="resourceDetail?.resource?.file">
											<!-- [data]="resourceDetail?.resource?.file | safeDom: 'resourceUrl'" -->
											<!-- data="https://www.amazon.in" -->
											<div class="resource-content document-container fx-column fx-start-stretch">
												<ng-container
													*ngIf="detectDevice?.resolutionState$?.value?.deviceType === 'desktop' && documentLoaded">
													<div class="object-tag-controls fx-row fx-space-between-stretch">
														<div></div>
														<div class="control">
															<button class="control-item btn-control" mat-icon-button (click)="fullScreen(objectData)">
																<mat-icon>fullscreen</mat-icon>
															</button>
														</div>
													</div>
												</ng-container>
												<object [data]="resourceDetail?.resource?.file | safeDom: 'resourceUrl'" type="application/pdf"
													width="100%" height="100%" class="viewer" [ngClass]="{'document-loaded': documentLoaded}"
													#objectData>
													<p>Your web browser doesn't have a proper plugin.
														Instead you can <a [attr.href]="resourceDetail?.resource?.file" target="_blank">click here
															to
															download the file.</a></p>
												</object>

											</div>
										</ng-container>
									</ng-container>
									<ng-container *ngIf="resourceDetail?.resourceFormat.key === 'link'">
										<ng-container
											*ngIf="resourceDetail?.resource?.urlData?.isFormatted && resourceDetail?.resource?.urlData?.type === 'youtube'">
											<div class="resource-content embed-player-container">
												<loader [loader]="youtubeLoader"></loader>
												<div class="ratio-player">
													<div class="ratio-content">
														<div id="YTPlayer"></div>
														<!-- <iframe class="ratio-content" width="100%" height="100%"
														[src]="resourceDetail?.resource?.urlData?.url | safeDom : 'resourceUrl'" frameborder="0"
														allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
														allowfullscreen></iframe> -->
													</div>
												</div>
											</div>
										</ng-container>

										<ng-container
											*ngIf="!resourceDetail?.resource?.urlData?.isFormatted || resourceDetail?.resource?.urlData?.type !== 'youtube'">
											<div class="embed-view view-gap"
												[ngClass]="{'fx-row fx-start-start' : !detectDevice?.resolutionState$?.value?.xs, 'fx-column fx-start-stretch' : detectDevice?.resolutionState$?.value?.xs}">
												<div class="thumbnail-block fx-no-grow fx-no-shrink">
													<div class="thumbnail cursor-pointer" (click)="embedLink(resourceDetail?.resource?.link)">
														<img [src]="resourceDetail?.resource?.thumbnail | safeDom : 'url'"
															(error)="gfService.setErrorImage($event, 'broken_image')" alt="">
													</div>
												</div>
												<div class="embed-content fx-column fx-start-stretch fx-grow fx-shrink">
													<ng-container *ngIf="resourceDetail?.title">
														<div class="fx-row fx-start-start">
															<P class="resource-title linkable" (click)="embedLink(resourceDetail?.resource?.link)">
																{{resourceDetail?.title}}</P>
															<mat-icon class="link-icon">open_in_new</mat-icon>
														</div>
													</ng-container>
													<ng-container *ngIf="resourceDetail?.resource?.link">
														<p class="sub-caption-2">{{locale.translate('source')}}</p>
														<p class="embed-url sub-caption-2 linkable"
															(click)="embedLink(resourceDetail?.resource?.link)">{{resourceDetail?.resource?.link}}</p>
													</ng-container>
												</div>
											</div>
										</ng-container>

									</ng-container>
									<ng-container *ngIf="resourceDetail?.resourceFormat.key === 'page'">
										<ng-container *ngIf="resourceDetail?.resource?.innerHtml">
											<app-readability [height]="'275'" (readMore)="readMore($event)">
												<content>
													<div class="page-readability" [innerHtml]="resourceDetail?.resource?.innerHtml | safeDom"></div>
												</content>
											</app-readability>
										</ng-container>
									</ng-container>
								</ng-container>
							</div>
							<div class="feature-placeholder fx-column fx-start-stretch"
								[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'block' : 'none'}">
							</div>
						</ng-container>

						<ng-container *ngIf="resourceDetail?.linkedResource?.length">
							<app-collapsible-area [data]="{title: locale.translate('linked_resources')}"
								[toggle]="{expanded: true, showToggle: false}" color="#fff">
								<div class="linked-resource-content-area" fxFlex="1 1" fxLayout="row wrap" fxLayoutAlign="start stretch"
									fxLayoutGap="15px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
									<ng-container
										*ngFor="let resource of resourceDetail?.linkedResource; trackBy: gfService.trackByID.bind({'key': 'resourceID'});let resourceIndex = index">

										<div class="linked-item" fxLayout="row wrap" fxLayoutAlign="start stretch"
											[ngClass]="{'xl' : detectDevice?.resolutionState$?.value?.xl,'lg' : detectDevice?.resolutionState$?.value?.lg,'md' : detectDevice?.resolutionState$?.value?.md,'sm' : detectDevice?.resolutionState$?.value?.sm, 'xs' : detectDevice?.resolutionState$?.value?.xs}">
											<ng-container
												*ngIf="!['playlist', 'answer','internalEvent', 'externalEvent'].includes(resource?.resourceTypeID?.key)">
												<app-content-image-card [record]="resource" [type]="'minimal'"
													(detail)="loadResource(resource)">
												</app-content-image-card>
											</ng-container>
											<ng-container *ngIf="resource?.resourceTypeID?.key === 'playlist'">
												<app-playlist-card [data]="resource" [type]="'minimal'" (detail)="loadResource(resource)">
												</app-playlist-card>
											</ng-container>
											<ng-container *ngIf="resource?.resourceTypeID?.key === 'answer'">
												<app-question-card [type]="'minimal'" [data]="resource" (detail)="loadResource(resource)">
												</app-question-card>
											</ng-container>
											<ng-container *ngIf="['internalEvent', 'externalEvent'].includes(resource?.resourceTypeID?.key)">
												<app-event-card [type]="'minimal'" [data]="resource" (detail)="loadResource(resource)">
												</app-event-card>
											</ng-container>
										</div>
									</ng-container>
								</div>
							</app-collapsible-area>
						</ng-container>

						<ng-container
							*ngIf="resourceDetail?.settings?.commenting !== 'hide' && resourceDetail?.resourceTypeID?.key !== 'course'">
							<div class="fx-row fx-start-start">
								<app-conversation [data]="{resourceData: resourceDetail}" fxFlex="0 1 760px" fxFlex.xs="auto"
									(recordCount)="updateCommentCount($event)" (reloadResource)="reload($event)">
								</app-conversation>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</content-area>
		</app-classic-content-view>
	</ng-container>
</div>
